import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-8 px-4 md:px-6 lg:px-8 bg-gray-800 text-gray-300">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Aura Connect Limited</h3>
            <p>Bringing hearts together in the golden years.</p>
          </div>
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="#" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-white transition-colors">
                  Safety Tips
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div> */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <p>Email: support@silverconnections.com</p>
            <p>Phone: (555) 123-4567</p>
          </div> */}
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p>
            &copy; {new Date().getFullYear()} Aura Connect Limited. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
